<template>
  <div class="agency-list">
    <searchBar
      class="search-bar"
      title="代理列表"
      :searchWidth="1100"
      @handleAgencyList="handleAgencyList"
      @handleAddNewAgent="handleAddNewAgent"
    />
    <el-table
      :data="tableData"
      style="width: 100%"
      :header-cell-style="{ background: '#66b1ff' ,color:'#fff'}"
      :row-class-name="tableRowClassName"
    >
      <el-table-column v-bind="item" v-for="(item,i) in tableHeader" :key="i"></el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button @click="handleEditeAgent(scope.row)" type="text" size="small">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100 ,200]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageData.totalCount"
      ></el-pagination>
    </div>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="700px"
      :before-close="handleClose"
    >
      <div class="dialog-content">
        <div class="input-content">
          <span class="accout-span">代理名称</span>
          <el-input placeholder="请输入代理名称" v-model="formData.agentAccount" clearable></el-input>
        </div>

        <div class="input-content" v-if="acoutshow">
          <span class="accout-span">代理登录账号</span>
          <el-input placeholder="请输入代理登录账号" v-model="formData.agentLoginAccount" clearable></el-input>
        </div>

        <div class="input-content">
          <span class="accout-span">代理登录密码</span>
          <el-input placeholder="请输入代理登录密码" v-model="formData.agentPass" clearable></el-input>
        </div>

        <div class="input-content" style="height: 50px;">
          <span class="accout-span">代理商状态</span>
          <el-switch
            v-model="agentState"
            :active-value="1"
            :inactive-value="0"
            active-color="#66b1ff"
            inactive-color="#c1c1c1"
          ></el-switch>
        </div>

        <div class="input-content">
          <span class="accout-span">设置上级代理</span>
          <el-select v-model="agentValue" filterable placeholder="请选择" class="select">
            <el-option
              v-for="item in agentList"
              :key="item.id"
              :label="item.userAccout"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>

        <div class="input-content">
          <span class="accout-span">设置渠道包链接</span>
          <el-input placeholder="请输入设置渠道包链接" v-model="formData.agnetLink" clearable></el-input>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAddAgent">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import searchBar from "@/components/search-bar";
import {
  apiGetAgentInfoPage,
  apiAddNewAgent,
  apiGetAgentList,
  apiGetAgentDataInfo,
  apiEditAgentDataInfo,
} from "@/api/userApi";
import { Message } from "element-ui";
import { getThisMonth } from "@/utills/formatTime.js";
export default {
  components: {
    searchBar,
  },
  data() {
    return {
      tableHeader: [
        {
          prop: "superiorsNickName",
          label: "上级代理",
          width: "80",
          fixed: "left",
        },
        {
          prop: "userAccout",
          label: "代理账号",
          width: "150",
          fixed: "left",
        },
        {
          prop: "userNickName",
          label: "代理名称",
          width: "120",
        },
        {
          prop: "agentId",
          label: "代理ID",
          width: "80",
        },
        {
          prop: "userCreateTimeText",
          label: "注册日期",
          width: "180",
        },
        {
          prop: "registerCount",
          label: "注册人数",
          width: "120",
        },
        {
          prop: "firstDepositTopAmount",
          label: "首充",
          width: "120",
        },
        {
          prop: "sumRechargeAmount",
          label: "充值",
          width: "120",
        },
        {
          prop: "topUpWithdrawDifference",
          label: "充值差",
          width: "120",
        },
        {
          prop: "earningInAmount",
          label: "钻石消费",
          width: "120",
        },
        {
          prop: "sumBonusAmount",
          label: "红利",
          width: "120",
        },
        {
          prop: "sumReceiveRebate",
          label: "返利",
          width: "120",
        },
        {
          prop: "moneyFee",
          label: "充值手续费",
          width: "120",
        },
        {
          prop: "accountRegulation",
          label: "调账",
          width: "120",
        },
        {
          prop: "sumBet",
          label: "游戏投注",
          width: "120",
        },
        {
          prop: "validSumBet",
          label: "有效投注",
          width: "120",
        },
        {
          prop: "profitLoss",
          label: "游戏盈亏",
          width: "120",
        },
        {
          prop: "activeCount",
          label: "活跃",
          width: "120",
        },
        {
          prop: "gamePercentConversion",
          label: "游戏转化率",
          width: "120",
        },
        {
          prop: "phonePercentConversion",
          label: "手机绑定率",
          width: "120",
        },
        {
          prop: "balancePercentConversion",
          label: "钻石转化率",
          width: "120",
        },
        {
          prop: "topUpPercentConversion",
          label: "充值率",
          width: "120",
        },
        {
          prop: "firstDepositPercentConversion",
          label: "首充率",
          width: "120",
        },
        {
          prop: "againAccountTopUpPercentConversion",
          label: "复充率",
          width: "120",
        },
        {
          prop: "netProfit",
          label: "净盈利",
          width: "120",
        },
      ],
      tableData: [],
      currentPage: 1,
      pageIndex: 1,
      pageSize: 10,
      sendData: {},
      pageData: {},
      dialogTitle: "",
      dialogVisible: false,
      agentState: 1,
      acoutshow: true,
      formData: {
        agentAccount: "",
        agentLoginAccount: "",
        agentPass: "",
        agnetLink: "",
        agentID:''
      },
      agentValue: 0,
      agentList: [
        {
          id: 0,
          userAccout: "官方",
        },
      ],
    };
  },
  async mounted() {
    this.sendData = {
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      agentName: "",
      agentAccount: "",
      isWin: 0, // 0 全部  1 赢  2 输
      beginTime: getThisMonth(Date.now()).firstDatOfMonth,
      endTime: getThisMonth(Date.now()).lastDatOfMonth,
    };
    await this.sendApiGetAgentInfoPage(this.sendData);
    const res = await this.sendApiGetAgentList();
    this.agentList = [...this.agentList, ...res.data];
  },

  watch: {
    dialogVisible: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          this.formData.agentAccount = "";
          this.formData.agentLoginAccount = "";
          this.formData.agentPass = "";
          this.formData.agnetLink = "";
          this.agentValue = 0;
          this.agentState = 1;
          this.formData.agentID = ''
        }
      },
    },
  },

  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 !== 0) {
        return "first-row";
      } else {
        return "second-row";
      }
    },

    async handleSizeChange(val) {
      this.pageSize = val;
      this.pageIndex = this.currentPage = 1;
      const data = {
        ...this.sendData,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      await this.sendApiGetAgentInfoPage(data);
    },

    async handleCurrentChange(val) {
      this.pageIndex = this.currentPage = val;
      const data = {
        ...this.sendData,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      await this.sendApiGetAgentInfoPage(data);
    },

    async sendApiAddNewAgent(data) {
      try {
        const res = await apiAddNewAgent(data);
        if (res.success) {
          Message.success("新增成功");
          this.dialogVisible = false;
          return res;
        } else {
          Message.error(res.message);
        }
      } catch (error) {
        Message.error("新增失败");
        console.log("error", error);
      }
    },
    async sendApiGetAgentList() {
      try {
        const res = await apiGetAgentList();
        if (res.success) {
          return res;
        }
      } catch (error) {
        Message.error("查询失败");
        console.log("error", error);
      }
    },
    async sendApiGetAgentInfoPage(data) {
      try {
        const res = await apiGetAgentInfoPage(data);
        console.log("res", res);
        if (res.success) {
          this.tableData = res.data.data;
          this.pageData = res.data;
        }
      } catch (error) {
        Message.error("查询失败");
        console.log("error", error);
      }
    },
    async sendApiGetAgentDataInfo(id) {
      try {
        const res = await apiGetAgentDataInfo(id);
        if (res.success) {
          return res;
        }
      } catch (error) {
        Message.error("查询失败");
        console.log("error", error);
      }
    },
    async sendApiEditAgentDataInfo(data) {
      try {
        const res = await apiEditAgentDataInfo(data);
        if (res.success) {
          Message.success("操作成功");
          this.dialogVisible =false
        }
      } catch (error) {
        Message.error("查询失败");
        console.log("error", error);
      }
    },

    async handleAgencyList(data) {
      this.sendData = data;
      const submitData = {
        ...this.sendData,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
      };
      await this.sendApiGetAgentInfoPage(submitData);
    },

    handleClose(done) {
      done();
    },
    handleAddNewAgent(data) {
      this.dialogVisible = data.bool;
      this.dialogTitle = data.title;
    },
    async handleAddAgent() {
      if (this.dialogTitle === "新增代理") {
        if (this.formData.agentAccount == "") {
         return  Message.error("代理名称不能为空");
        }
        if (this.formData.agentLoginAccount == "") {
          return Message.error("代理登录账号不能为空");
        }

        if (this.formData.agentPass == "") {
          return  Message.error("代理登录密码不能为空");
        }

        if (this.formData.agnetLink == "") {
          return  Message.error("渠道包链接不能为空");
        }
        const data = {
          userAccout: this.formData.agentLoginAccount,
          userPassword: this.formData.agentPass,
          userNickName: this.formData.agentAccount,
          userState: 1,
          userSuperiors: 0,
          userChannelId: 0,
          userLink: this.formData.agnetLink,
        };
        const res = await this.sendApiAddNewAgent(data);

        if (res?.success) {
          await this.sendApiGetAgentInfoPage(this.sendData);
        }
      } else {
        if (this.formData.agentAccount == "") {
          return  Message.error("代理名称不能为空");
        }

        if (this.formData.agnetLink == "") {
          return  Message.error("渠道包链接不能为空");
        }

        const data = {
          agentId:+this.formData.agentID ,
          userNickName: this.formData.agentAccount,
          userState: this.agentState,
          userSuperiors: this.agentValue,
          password:this.formData.agentPass ? this.formData.agentPass : '',
          userLink: this.formData.agnetLink,
        };

        this.sendApiEditAgentDataInfo(data)
      }
    },

    async handleEditeAgent(row) {
      this.dialogTitle = "编辑代理";
      this.dialogVisible = true;
      this.acoutshow = false;
      const res = await this.sendApiGetAgentDataInfo(row.agentId);
      this.formData.agentID = row.agentId
      this.formData.agentAccount = res.data.userNickName;
      this.formData.agnetLink = res.data.userLink;
      this.agentValue = res.data.userSuperiors;
      this.agentState = res.data.userState;
    },
  },
};
</script>

<style lang="less" >
.agency-list {
  position: relative;
  .first-row {
    background: rgb(219, 219, 219) !important;
  }

  .second-row {
    background: #d4e4fc !important;
  }

  .search-bar {
    margin-bottom: 30px;
  }

  .pagination {
    margin-top: 30px;
    position: absolute;
    right: 50px;
  }

  .dialog-content {
    .input-content {
      display: flex;
      align-items: baseline;
      justify-content: left;
      margin-left: 50%;
      width: 500px;
      transform: translateX(-50%);
      .el-input {
        width: 45% !important;
        margin-bottom: 20px;
      }

      .accout-span {
        margin-right: 20px;
        width: 100px;
      }
    }

    .adjust {
      margin-top: 20px;
    }
  }
}
</style>